import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, ISelectCardOperation, ISelectCardOption } from "../../../constants/types";
import Icon from "../../icon/Icon";

import './SelectCardOperation.scss'

interface Props extends WithTranslation{
    operation: ISelectCardOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

class SelectCardOperation extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    onSelect(id: string) {
        this.setState({selected: id}, () => this.props.onChange({
            OK: true,
            discarded: false,
            value: id
        }));
    }

    renderOptions(options: ISelectCardOption[]) {
        const { data, operation } = this.props;

        return <Row className="select-card-list">
            {options.map(op => {
                return <Col key={`${operation.type}-${op.id}`} xs={6} md={3} className="fade-in">
                    <div className="select-card" aria-selected={op.id === data?.value} onClick={() => this.onSelect(op.id)}>
                        <div className="select-card-checkmarker">
                            <Icon type={"CHECKMARK"} iconProps={{ size: '1.5rem' }}/>
                        </div>
                        <div className="select-card-icon">
                            <Icon type={op.icon} iconProps={{ size: '4rem' }}/>
                        </div>
                        <div className="select-card-title">
                            {this.props.t(op.name as unknown as TemplateStringsArray)}
                        </div>
                    </div>
                </Col>;
            })}
        </Row>
    }

    render() {
        const { operation } = this.props;
        return <div className="render-select-card-operation" >
            {this.renderOptions(operation.options)}
        </div>;
    }
};

export default withTranslation()(SelectCardOperation);